import { type WidgetOfferPeriod } from 'src/types/widget-offers';

export const getInstallmentPeriod = (
  t: (value: string) => string,
  period?: WidgetOfferPeriod
) => {
  if (!period) {
    return t('month');
  }

  switch (period.size) {
    case 'day':
      return t('day');
    case 'week':
      return period.value === 1 ? t('week_one') : t('week_other');
    default:
      return t('period');
  }
};
